/* global globalThis */
import { useContext, useEffect } from 'react';
import { useCountryConfig } from 'hooks/useCountryConfig';
import { Context } from 'context';
import { PYLON_SERVICES } from 'Services';

const PYLON_SNIPPET_ID = 'pylon-snippet';

function setPylonChatSettings(appId, user, identity) {
  const verified = Boolean(identity?.email && identity?.email_hash);
  const email = verified ? identity.email : user.email;

  globalThis.pylon = {
    chat_settings: {
      app_id: appId,
      email,
      name: user.name || email,
      ...(verified ? { email_hash: identity.email_hash } : {}),
    },
  };
}

async function fetchPylonIdentity() {
  try {
    const response = await PYLON_SERVICES.initPylonChat();
    return response?.type === 'success' ? response.data : null;
  } catch {
    return null;
  }
}

function ensurePylonQueue() {
  if (globalThis.Pylon) {
    return;
  }

  const pylonQueue = function () {
    pylonQueue.e(arguments);
  };
  pylonQueue.q = [];
  pylonQueue.e = (args) => {
    pylonQueue.q.push(args);
  };
  globalThis.Pylon = pylonQueue;
}

function loadPylonSnippet(widgetUrl, appId) {
  ensurePylonQueue();

  if (document.getElementById(PYLON_SNIPPET_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.id = PYLON_SNIPPET_ID;
  script.type = 'text/javascript';
  script.async = true;
  script.src = `${widgetUrl}/${appId}`;
  document.head.appendChild(script);
}

const PylonWidget = () => {
  const { config: countryConfig } = useCountryConfig();
  const {
    state: { user },
  } = useContext(Context);

  const pylonAppId = countryConfig?.pylonAppId;
  const pylonWidgetUrl = countryConfig?.pylonWidgetUrl;
  const userEmail = user?.email;
  const userName = user?.name;

  useEffect(() => {
    if (!pylonAppId || !pylonWidgetUrl) {
      return undefined;
    }

    if (!userEmail) {
      globalThis.Pylon?.('hideChatBubble');
      return undefined;
    }

    let cancelled = false;

    const showPylonChat = async () => {
      const identity = await fetchPylonIdentity();
      if (cancelled) {
        return;
      }

      setPylonChatSettings(
        pylonAppId,
        { email: userEmail, name: userName },
        identity,
      );
      loadPylonSnippet(pylonWidgetUrl, pylonAppId);
      globalThis.Pylon?.('showChatBubble');
    };

    void showPylonChat();

    return () => {
      cancelled = true;
    };
  }, [pylonAppId, pylonWidgetUrl, userEmail, userName]);

  return null;
};

export default PylonWidget;
